import { useEffect, useState } from "react";
import { Form, Button, Modal, Container, Row, Col } from "react-bootstrap";

const DeviceForm = ({ selectedDevice, onSave, showModal, handleCloseModal }) => {
    const [formData, setFormData] = useState({
        device_id: "",
        name: "",
        status: "",
        device_description: ""
    });

    const [formErrors, setFormErrors] = useState({
        device_id: "",
        name: "",
        status: "",
        device_description: ""
    });

    // Retrieve the relevant device data for editing
    useEffect(() => {
        if (selectedDevice) {
            setFormData({
                ...selectedDevice,
            });
        } else {
            // Clear the form for a new device
            setFormData({
                device_id: "",
                name: "",
                status: "",
                device_description: ""
            });
        }
    }, [selectedDevice]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "", // Clears the error for the specific field
        }));

        // Update the form data with the new value
        setFormData((prevData) => ({
            ...prevData,
            [name]: name === "created_at" ? new Date(value).toISOString().slice(0, 16) : value,
        }));
    };

    const validateForm = () => {
        const errors = {};
        let isValid = true;

        // Check if each required field is filled
        Object.keys(formData).forEach((key) => {
            if (formData[key] === "" || formData[key] === 0) {
                errors[key] = `${key
                    .replace(/([A-Z])/g, " $1")
                    .toLowerCase()} is required.`;
                isValid = false;
            }
        });

        setFormErrors(errors);
        return isValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            onSave(formData); // Save the data
        }
        setFormData({
            device_id: "",
            name: "",
            status: "",
            device_description: ""
        });
    };

    return (
        <Modal show={showModal} onHide={handleCloseModal} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    {selectedDevice ? "Edit Device" : "Add New Device"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container fluid>
                    <Row className="justify-content-md-center">
                        <Col xs={12}>
                            <Form onSubmit={handleSubmit}>

                                {/* Device ID & Device Name */}
                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group controlId="formName" className="mb-3">
                                            <Form.Label>Device ID</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="device_id"
                                                value={formData.device_id}
                                                onChange={handleChange}
                                                placeholder="Enter device ID"
                                                isInvalid={
                                                    !!formErrors.device_id
                                                }
                                            />
                                            {formErrors.device_id && (
                                                <p className="text-danger">
                                                    {formErrors.device_id}
                                                </p>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="name" className="mb-3">
                                            <Form.Label>Device Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                placeholder="Enter device name"
                                                isInvalid={!!formErrors.name}
                                            />
                                            {formErrors.name && (
                                                <p className="text-danger">
                                                    {formErrors.name}
                                                </p>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {/* Status */}
                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group controlId="formStatus" className="mb-3">
                                            <Form.Label>Status</Form.Label>
                                            <Form.Select
                                                name="status"
                                                value={formData.status}
                                                onChange={handleChange}
                                                isInvalid={!!formErrors.status}
                                            >
                                                <option value="">Select status</option>
                                                <option value="active">Active</option>
                                                <option value="inactive">Inactive</option>
                                                <option value="maintenance">Maintenance</option>
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                                {formErrors.status}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {/* Description */}
                                <Row className="mb-3">
                                    <Col md={12}>
                                        <Form.Group
                                            controlId="description"
                                            className="mb-3"
                                        >
                                            <Form.Label>Description</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="device_description"
                                                value={formData.device_description || ""}
                                                onChange={handleChange}
                                                placeholder="Enter description (optional)"
                                                isInvalid={!!formErrors.device_description}
                                            />
                                            {formErrors.device_description && (
                                                <p className="text-danger">
                                                    {formErrors.device_description}
                                                </p>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Button type="submit" variant="primary" className="mb-3"> Save </Button>
                            </Form>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
        </Modal>
    );
};

export default DeviceForm;